import { createPinia } from 'pinia';
import { createPersistedState } from 'pinia-plugin-persistedstate';

const pinia = createPinia();

// 添加持久化插件
pinia.use(createPersistedState({
  // 持久化配置
  storage: localStorage,
  key: id => `xicrm_${id}`,
}));

export default pinia;

// 导出所有的store，方便统一管理
export * from './auth';
export * from './user';
export * from './app';
export * from './network';  // 导出网络状态存储 